import { Component } from '@angular/core';
import { APPCONFIG } from '../../config';
import { UserService } from '../../services/UserService';
import { AdalService } from '../../shared/adal.service';
import { Router } from '@angular/router';
@Component({
    selector: 'my-app-sidenav',
    styles: [],
    template: require('./sidenav.component.html')
})

export class AppSidenavComponent {
    AppConfig;
    IsAdmin:boolean;
    errorMessage:string;

    constructor(private userservice: UserService,private adalService: AdalService,private router: Router){    
        if (!this.adalService.getCachedToken()){            
            this.router.navigate(['login']);
        }            
    }        

    ngOnInit() {
        this.getUserRights(Number(localStorage.getItem('userid')));
        this.AppConfig = APPCONFIG;
    }

    toggleCollapsedNav() {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    }

    getUserRights(UserId){                        
        this.userservice.getUserById(UserId).subscribe(
            Data => {                                              
                this.IsAdmin = Data.IsAdmin;                
            },
             error => {
                this.errorMessage = error;
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav.component.ts